/* eslint-disable */
import React from "react";
import { RiMapPinLine, RiUser3Line, RiUserStarLine } from "react-icons/ri";
import styles from "./LK.module.css";

const MONTHS = [
  "января", "февраля", "марта", "апреля", "мая", "июня",
  "июля", "августа", "сентября", "октября", "ноября", "декабря",
];

const WEEKDAYS = [
  "воскресенье", "понедельник", "вторник", "среда",
  "четверг", "пятница", "суббота",
];

function formatDate(dateString) {
  const date = dateString ? new Date(dateString) : new Date();
  if (isNaN(date.getTime())) return "";
  return `${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()} г., ${WEEKDAYS[date.getDay()]}`;
}

function formatTime(item) {
  if (item.time_start && item.time_end) return `${item.time_start} – ${item.time_end}`;
  return item.time_start || item.time_end || "";
}

export default function LKSchedule({ scheduleToday }) {
  const items = (scheduleToday && scheduleToday.items) || [];

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div>
          <h3 className={styles.cardHeaderTitle}>Расписание на сегодня</h3>
          <p className={styles.cardHeaderSubtitle}>
            {formatDate(scheduleToday && scheduleToday.date)}
          </p>
        </div>
      </div>

      <div className={styles.cardBody}>
        {items.length ? (
          <div className={styles.timeline}>
            {items.map((item, index) => {
              const isLesson = item.record_type === "Занятие";
              const isLast = index === items.length - 1;
              const place = isLesson
                ? item.rooms || item.room || item.place
                : item.place;
              const group = item.subgroup || item.groups || item.group;

              return (
                <div key={index} className={styles.timelineItem}>
                  <div className={styles.dotCol}>
                    <div className={styles.dot} />
                    {!isLast && <div className={styles.connector} />}
                  </div>

                  <div className={styles.eventBlock}>
                    <div className={styles.eventCard}>
                      <div className={styles.eventTopRow}>
                        <span className={styles.timeBadge}>{formatTime(item)}</span>
                        {isLesson ? (
                          <span className={`${styles.typeBadge} ${styles.typeBadgeLesson}`}>
                            {item.lesson_type || "Занятие"}
                          </span>
                        ) : (
                          <span className={`${styles.typeBadge} ${styles.typeBadgeEvent}`}>
                            Мероприятие
                          </span>
                        )}
                      </div>

                      <h4 className={styles.eventTitle}>
                        {isLesson ? item.discipline : item.title}
                      </h4>

                      <div className={styles.eventDetails}>
                        {place && (
                          <span className={styles.detailItem}>
                            <RiMapPinLine className={styles.detailIcon} size={14} />
                            {place}
                          </span>
                        )}
                        {isLesson && group && (
                          <span className={styles.detailItem}>
                            <RiUser3Line className={styles.detailIcon} size={14} />
                            {group}
                          </span>
                        )}
                        {isLesson && item.teacher && (
                          <span className={styles.detailItem}>
                            <RiUserStarLine className={styles.detailIcon} size={14} />
                            {item.teacher}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className={styles.emptySchedule}>
            На сегодня занятий и мероприятий нет
          </div>
        )}
      </div>
    </div>
  );
}
